// tracking event names
export const EVENT_NAMES = {
  ///////////////////////////
  // Cross Media Plan Module

  // Workflow Events
  CROSSMEDIA_START: 'CrossMedia_Start',
  CROSSMEDIA_TAB_START: 'CrossMedia_Tab_Start',
  CROSSMEDIA_TAB_EDIT: 'CrossMedia_Tab_Edit',
  CROSSMEDIA_TAB_DUPLICATE: 'CrossMedia_Tab_Duplicate',
  CROSSMEDIA_TAB_STEP: 'CrossMedia_Tab_Step', // `${CROSSMEDIA_TAB_STEP}_${nextStep}` (only 1, 2 and 3 exist)
  CROSSMEDIA_TAB_COMPLETE: 'CrossMedia_Tab_Complete',
  CROSSMEDIA_TAB_EXIT: 'CrossMedia_Tab_Exit',
  CROSSMEDIA_EXIT: 'CrossMedia_Exit',
  // Regular Events
  CROSSMEDIA_DELETE: 'CrossMedia_Delete',
  CROSSMEDIA_EXPORT: 'CrossMedia_Export',

  // Self-Directed Marketing Mix Model Module
  SDMMM_START: 'SDMMM_Start', // START OF WORKFLOW // When user hits "Create Model"
  SDMMM_EDIT: 'SDMMM_Edit', // START OF WORKFLOW // When user hits "Edit Model"
  SDMMM_STEP: 'SDMMM_Step', // `${SDMMM_STEP}_${nextStep}` (only 0 and 1 exist for now)
  SDMMM_GSHEET_GOTO: 'SDMMM_GSheet_Goto', // User used Google Sheets (go to Google Sheets)
  SDMMM_GSHEET_SYNC: 'SDMMM_GSheet_Sync', // Sync from Google Sheets (Sync from Google Sheets)
  SDMMM_SYNC_DATA: 'SDMMM_Sync_Data', // Sync integration data
  SDMMM_ADD_CHANNEL: 'SDMMM_Add_Channel', // Add a new channel
  SDMMM_DELETE_CHANNEL: 'SDMMM_Delete_Channel', // Delete a channel
  SDMMM_UPDATE_CHANNEL: 'SDMMM_Update_Channel', // Update a channel
  SDMMM_SAVE: 'SDMMM_Save', // Model saved (since it can be saved at any time, it's not considered a workflow end)
  SDMMM_BUILD: 'SDMMM_Build', // END OF WORKFLOW // Model build request success (set workflowId to null which ends the workflow)
  SDMMM_EXIT: 'SDMMM_Exit', // END OF WORKFLOW // Exit component

  // Marketing Mix Model Module
  MMM_START: 'MMM_Start',
  MMM_VIEW: 'MMM_View', // `MMM_View_${view}` (view === salesForecast, mediaROI, ommGraph, roas, channelAttribution, weeklyAttributions, synergy, adstockSpend)
  MMM_EXPORT: 'MMM_Export', // Export MMM data
  MMM_EXIT: 'MMM_Exit', // Exit component

  // Location Intelligence Module
  LOCINTELLIGENCE_START: 'LocationIntelligence_Start',
  LOCINTELLIGENCE_VIEW: 'LocationIntelligence_View', // `LocationIntelligence_View_${view}` (view === FSA, FED, POSTAL, etc)
  LOCINTELLIGENCE_SEARCH: 'LocationIntelligence_Search',
  LOCINTELLIGENCE_EXPORT: 'LocationIntelligence_Export',
  LOCINTELLIGENCE_EXIT: 'LocationIntelligence_Exit',

  // Audience Builder Module
  AUDIENCEBUILDER_START: 'AudienceBuilder_Start',
  AUDIENCEBUILDER_PICK_DATASET: 'AudienceBuilder_Pick_Dataset', // Theme selected
  AUDIENCEBUILDER_PICK_TABLE: 'AudienceBuilder_Pick_Table', // Category selected
  AUDIENCEBUILDER_PICK_VARIABLE: 'AudienceBuilder_Pick_Variable', // Attribute selected
  AUDIENCEBUILDER_PICK_VALUE: 'AudienceBuilder_Pick_Value', // Variable selected
  AUDIENCEBUILDER_SWITCH_BUILDER: 'AudienceBuilder_Switch_Builder', // `AudienceBuilder_Switch_Builder_${builder}` (builder === Simple, Advanced, CRM)
  AUDIENCEBUILDER_COMPLETE: 'AudienceBuilder_Complete',
  AUDIENCEBUILDER_EXIT: 'AudienceBuilder_Exit',

  // Personal Builder Module
  PERSONALBUILDER_AUDIENCE_OVERVIEW: 'PersonalBuilder_Audience_Overview',
  PERSONALBUILDER_MEDIA_USAGE: 'PersonalBuilder_Media_Usage',
  PERSONALBUILDER_CROSS_TAB: 'PersonalBuilder_Cross_Tab',
  PERSONALBUILDER_BEHAVIOR: 'PersonalBuilder_Behavior',

  // Report Module
  REPORT_SAVE_TAB: 'Report_Save_Tab', // gets a report_type property (type === LITYPE || BEHAVIOURTYPE || MEDIATYPE, etc)
  REPORT_DELETE_TAB: 'Report_Delete_Tab', // also gets a report_type property

  // InstaPoll Module
  INSTAPOLL_CLICK: 'InstaPoll_Click',
};
